export default __webpack_public_path__ + "static/media/curriculos-background.0cce55c7.png";